/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const data = {
  img: "https://i.ibb.co/JmP4n6P/shreedigital-showcased-asset-description-750-700.png",
  title: "Assets Displayed for Claim",
  description:
    "In this section you can view the assets that are put to showcase by you / your organisation in different Shree Digital supported marketplace.",
  meta: [
    {
      key: "",
      value: "From this section, you can,",
    },
    {
      key: "",
      value: "• Enable Claim of the asset by someone else. : If you have sold asset outside of the Shree Digital Platform, you can enable them to claim the asset by providing us the email id of the purchaser. The purchaser can Claim the asset from Marketplace & we will ensure they are indeed the owner of that email id via our verifications.",
    },
    {
      key: "",
      value: "- Read More",
    },
    {
      key: "",
      value: "• Claim Assets - Grid View",
      path: "/claim-assets",
    },
    {
      key: "",
      value: "• Claim Assets - Table View",
      path: "/claim-assets-table",
    },
  ],
  // buttons: [
  //   {
  //     key: "edit",
  //     title: "Edit",
  //   },
  // ],

  };